import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { publicProjectsQuery, siteSettingsQuery } from "@/lib/query-registry";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import type { PublicProject } from "@/components/site/WorkContent";

export const Route = createFileRoute("/es/proyectos")({
  head: () => buildHead({
    locale: "es",
    title: "Casos Shopify: Decisiones, Delivery y Resultados · Shugert",
    description: "Casos Shopify seleccionados que documentan la restricción inicial, intervención, evidencia, límites y entrada comercial relacionada; no solo screenshots.",
    path: "/es/proyectos",
    altPath: alternatePath("/es/proyectos", "en"),
    jsonLd: breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Proyectos", path: "/es/proyectos" }]),
  }),
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    const [{ projects }, { settings }] = await Promise.all([
      context.queryClient.ensureQueryData(publicProjectsQuery()),
      context.queryClient.ensureQueryData(siteSettingsQuery()),
    ]);
    return {
      projects: projects as PublicProject[],
      workLimit: settings.work_projects_limit,
    };
  },
});
